import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { take, map, tap, delay, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CommonUtils } from '../common-utils/common-utils';

/* tslint:disable */ 
@Injectable({
  providedIn: 'root'
})
// CanLoad is need for befor module loaded it check auth true or false
export class AuthGuard implements CanLoad  {

  // variable
  get_path_name;

  constructor( 
    private authService : AuthService,
    private router : Router,
    private commonUtils: CommonUtils 
  ){
  }

  canLoad(
    route: Route, 
    segments: UrlSegment[]
    ): Observable<boolean> | Promise<boolean> | boolean{
     

      return this.authService.globalparamsData.pipe(
        take(1),
        switchMap(isAuthenticated => {
          if (!isAuthenticated) {
            return this.authService.autoLogin();
          } else {
            return of(!!isAuthenticated); //(!!) means true or false (boolean value)
          }
        }),
        tap(isAuthenticated => {
          if (!isAuthenticated) {
            this.router.navigateByUrl('/login');
          }
        })
      );

  }
}